import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import MyStorages from './MyStorages';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.myStorages;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(MyStorages);

export default connect(
  mapStateToProps,
)(Styled);
